module.exports = __webpack_public_path__ + "static/img/calvert-logo-transparent-background.123e24f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/calvert-logo-transparent-background.png
// module id = 1224
// module chunks = 1